export default __webpack_public_path__ + "static/realLeaf1-81d67e8e294f869a47e81228d8046e9b.png";